import { Drawer } from "antd";

const UpdateRuleStepDrawer = ({ open, setOpen }) => (
  <Drawer
    width={490}
    title="更新流程說明"
    open={open}
    onClose={() => setOpen(false)}
  >
    <div style={{ color: "#666" }}>
      工單更新規則用於設定當 ERP
      系統中符合同步規則的工單資訊發生變更時，如何將這些變更同步更新至 SFR
      系統。
      <br />
      <br />
      更新規則包括：
      <ul>
        <li>
          <strong>特定欄位：</strong>只有當 ERP
          系統中特定欄位（例如：更新時間、機台名稱等）發生變更時，才會觸發更新操作。
        </li>
        <li>
          <strong>任一欄位：</strong>只要 ERP
          系統中的任何欄位發生變更，系統就會將這些變更同步更新至 SFR 系統。
        </li>
      </ul>
      <br />
      建議根據實際業務需求選擇合適的更新條件，以確保 SFR 系統中的工單資訊與 ERP
      系統保持一致，從而提升生產管理的效率和準確性。
    </div>
  </Drawer>
);

export default UpdateRuleStepDrawer;
